import { TalentTreeBlueprintContextProvider } from '../../contexts/useTalentTreeBlueprint';
import { type RetailWarcraftTalentTreeBlueprint } from '../../typings/viewModels/retailWarcraftTalentTreeBuildNode';
import React, { type JSX } from 'react';
import EnhancedMarkdown from '../EnhancedMarkdown/EnhancedMarkdown';
import TalentTreeFull, {
  type TalentTreeFullProps,
} from '../TalentTreeFull/TalentTreeFull';
import VerticalContent from '../VerticalContent/VerticalContent';
import useGame from '../../contexts/useGame';
import useScript from '../../hooks/useScript';
import BuildsNoDataPlaceholder from '../BuildsNoDataPlaceholder/BuildsNoDataPlaceholder';
import buildsEnhancedMarkdownOverrides from '@resources/js/helpers/buildsEnhancedMarkdownOverrides';

export type BuildsPopularTalentsSectionProps = {
  title: string;
  description: string;
  talentTree: TalentTreeFullProps | null;
  talentTreeBlueprints: Record<string, RetailWarcraftTalentTreeBlueprint>;
};

export default function BuildsPopularTalentsSection({
  title,
  description,
  talentTree,
  talentTreeBlueprints,
}: BuildsPopularTalentsSectionProps): JSX.Element {
  const game = useGame();
  useScript(game.tooltipLibraryPath);

  return (
    <VerticalContent className='builds-popular-talents-section'>
      <EnhancedMarkdown
        markdown={`
# ${title}

${description}
`}
        overrides={buildsEnhancedMarkdownOverrides}
      />
      {talentTree ? (
        <TalentTreeBlueprintContextProvider preloaded={talentTreeBlueprints}>
          <TalentTreeFull
            {...talentTree}
            defaultExpanded
            hasToggleButton={false}
            exportCodeParams={null}
          />
        </TalentTreeBlueprintContextProvider>
      ) : (
        <BuildsNoDataPlaceholder />
      )}
    </VerticalContent>
  );
}
